module.exports = __webpack_public_path__ + "img/cooperation8.de057674.png";